import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sercret-lyunes',
  templateUrl: './sercret-lyunes.component.html',
  styleUrls: ['./sercret-lyunes.component.css']
})
export class SercretLyunesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
